import { render, staticRenderFns } from "./BarChart.vue?vue&type=template&id=386875a2&scoped=true"
import script from "./BarChart.vue?vue&type=script&setup=true&lang=ts"
export * from "./BarChart.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BarChart.vue?vue&type=style&index=0&id=386875a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386875a2",
  null
  
)

export default component.exports